import { Component, inject } from '@angular/core';
import { BaseComponent } from '../../../../../../models/base/base-component';
import { MemberAuthViewModel } from '../../../../viewModels/member-auth-view-model';
import { ConfirmMemberRequest } from '../../../../../../models/users/requests/confirm-member-request';
import { AssetSize } from 'src/app/models/enum/dto/asset-size.enum';
import { PasswordInputUtils } from '../../../../../../utils/password-input-utils';
import { createChoosePasswordFormGroup } from '../../../../forms/choose-password-form-group';

@Component({
  selector: 'app-member-setup',
  templateUrl: './member-setup.component.html',
  styleUrls: ['./member-setup.component.scss', '../../auth.component.scss']
})
export class MemberSetupComponent extends BaseComponent {
  viewModel = inject(MemberAuthViewModel);

  public formGroup = createChoosePasswordFormGroup({ emailDisabled: false });
  public formSubmitted = false;

  public hintText = $localize`Must use a personal email address`;

  public customErrorMessages = {
    password: {
      passwordMinLength: $localize`Password must be at least 8 characters`,
      passwordMaxLength: $localize`Password cannot exceed 50 characters`
    },
    eula: {
      required: $localize`Terms and Conditions must be accepted in order to continue.`
    }
  };

  public readonly AssetSize = AssetSize;
  public readonly passwordHintText = PasswordInputUtils.passwordHintText;

  setupBindings(): void {}

  setupViews(): void {}

  public submit(): void {
    this.formSubmitted = true;
    if (this.formGroup.invalid) {
      return;
    }
    const { email, password, eulaAccepted } = this.formGroup.getRawValue();
    this.viewModel.confirmMember(new ConfirmMemberRequest(email, password, eulaAccepted));
  }
}
